import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Presentation, PresentationState} from "../../../../core/gameflow/controller/Presentation";
import {GameData} from "../../../server/data/GameData";
import {SoundManager} from "../../../sound/SoundManager";
import {PREngineManager} from "../../../punkEngine/PREngineManager";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {PunkSymbol} from "../../../punkEngine/symbol/PunkSymbol";
import {BaseServerData, jumpingWildConfig} from "../../../server/base/IData";
import {ArrayHelper} from "../../../../core/utils/ArrayHelper";
import {PunkRocker} from "../../../PunkRocker";
import {JumpWildState} from "../../independent/jumpingWild/JumpingWildController";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";


export class ReelStoppedPresentation extends Presentation {
    protected normal: boolean = false;
    protected respin: boolean = false;
    protected mysterySymbol: string = "";
    protected mysteryPos: number[] = [];
    protected bonusGameWildTransformPos: boolean[][] = [];
    protected winReelLength: number = 0;
    protected killTheFire: boolean = false;
    protected symSizes: number[][];
    private _gameData: GameData;

    public setGamedData(data: GameData): void {
        this._gameData = data;

        this.winReelLength = data.Win.allBetWayWinData.longest;

        this.normal = data.mode == GameMode.NORMAL;
        this.respin = data.mode == GameMode.RESPIN;

        this.mysteryPos = data.Reel.mysteryPos;
        //this.xWildPos = data.Reel.xWildPos;
        this.symSizes = data.raw.symbolSizes;
        this.mysterySymbol = data.raw.mysterySymbolRevealed;
        this.killTheFire = !data.Win.singleWin;
        this.bonusGameWildTransformPos = this.calcWildTransformPos();

        // const nextIsFeature:boolean = data.nextMode != GameMode.NORMAL;

        // this.expandCheck = data.mysteryData != null && !!data.mysteryData!.mysterySymbolAppeared;

        // this.respinUnChain = data.mode == GameMode.RESPIN;
        // this.delayPreFeature = data.singleWin == 0 && this.normal && nextIsFeature;

        // this.totalWinAmount = data.totalWin;
        // this._lockedReelPositions = ArrayHelper.initArrayWithValues(PunkEngineManager.AllReels.length, () => false);
        // PunkEngineManager.AllReels.forEach(reel => { if(!reel.isActive) this._lockedReelPositions[reel.reelID] = true;});
    }

    skip() {
        super.skip();
    }

    public createPresentation(enableSkip: Function) {
        enableSkip(true);

        if (this.respin) {
            this.timeline.to(this, {duration: 1});
            this.respin = false;
        } else {
            if (this.killTheFire) {
                PREngineManager.RSAll((r, s) => s.killFire())
            }
            this.revealMysteries();
            if (this._gameData.isFreeSpin) {
                this.bonusGameWildTransform();
            }
            this.PresentationState.set(PresentationState.INACTIVE);
        }
    }

    public done(): void {
        //PREngineManager.RAll(r => r.changeReelAmount(3));
        Logger.logDev("Stopped Done");
    }

    private calcWildTransformPos(): boolean[][] {
        const rawGameData: BaseServerData = this._gameData.raw,
            topTrainFeatures: string[] = rawGameData.topTrain,
            tempPos: boolean[][] = ArrayHelper.initArrayWithValues(PREngineManager.AllReels.length, () => ArrayHelper.initArrayWithValues(rawGameData.evaluatedArea.length, () => false));

        for (let reelId: number = 0; reelId < tempPos.length; reelId++) {
            if (topTrainFeatures[reelId] === "MOLOTOV_FS") {
                const currReelEvalArea: string[] = rawGameData.evaluatedArea[reelId];
                if (currReelEvalArea.includes("JW")) {
                    for (let symId: number = currReelEvalArea.lastIndexOf("JW"); symId >= 0; symId--) {
                        if (currReelEvalArea[symId] !== "JW") {
                            tempPos[reelId][symId] = true;
                        }
                    }
                }
            }
        }

        return tempPos;
    }

    //MOLOTOV_FS trigger
    private bonusGameWildTransform(): void {
        const wildTransformDelay: number = MathHelper.frameToSeconds(13);
        let motoLovFound: boolean = false;

        for (let reelId: number = 0; reelId < this.bonusGameWildTransformPos.length; reelId++) {
            for (let symId: number = (this.bonusGameWildTransformPos[reelId].length - 1); symId >= 0; symId--) {
                if (this.bonusGameWildTransformPos[reelId][symId]) {
                    motoLovFound = true;

                    const currSym: PunkSymbol | undefined = PREngineManager.getReel(reelId).getSymbol(symId);

                    this.timeline.add(currSym!.WildTransform(), wildTransformDelay);

                    for (let i: number = 0; i < this._gameData.raw.jumpingWildList.length; i++) {
                        const currJWObj: jumpingWildConfig = this._gameData.raw.jumpingWildList[i];
                        if (reelId === currJWObj.newCoord.x && currJWObj.newCoord.y > 0) {
                            this.timeline.add(PunkRocker.jumpWilds.PlayState(i, JumpWildState.FEATURE_MOLOTOV_FS_TRIGGER), 0);
                        }
                    }
                }
            }
        }

        // #180
        if (motoLovFound) {
            this.timeline.add(() => {
                SoundManager.playWildTransformSound(false);
            }, wildTransformDelay);
        }

        for (let i: number = 0; i < this._gameData.raw.jumpingWildList.length; i++) {
            const rawGameData: BaseServerData = this._gameData.raw,
                currJWObj: jumpingWildConfig = rawGameData.jumpingWildList[i];

            if(rawGameData.topTrain[currJWObj.reelChosen] === "MOLOTOV_FS") {
                if(currJWObj.newCoord.y === 0) {
                    this.timeline.add(PunkRocker.jumpWilds.PlayState(i, JumpWildState.FEATURE_MOLOTOV_FS_TRIGGER_FAIL), 0);
                }

                if(currJWObj.newCoord.y > 0 && !(this.bonusGameWildTransformPos[currJWObj.reelChosen][currJWObj.newCoord.y - 1])) {
                    this.timeline.add(PunkRocker.jumpWilds.PlayState(i, JumpWildState.FEATURE_MOLOTOV_FS_TRIGGER_FAIL), 0);
                }
            }
        }
    }

    private revealMysteries(): void {
        let isSuper: boolean = false;

        this.timeline.add(() => {
            SoundManager.playSoundEffect(`xwaysExpand${isSuper ? "Super" : ""}`);
        }, 0);

        PREngineManager.AllReels.forEach(currReel => {
            if (currReel.isActive) {
                const reelId: number = currReel.reelID;

                if (this.mysteryPos[currReel.reelID] >= 0) {
                    const symId: number = this.mysteryPos[reelId],
                        currSymSize: number = this._gameData.raw.symbolSizes[reelId][symId],
                        currSym: PunkSymbol | undefined = currReel.getSymbol(symId);

                    isSuper = isSuper || currSymSize > 9;

                    // #319
                    if (currSymSize > 9) {
                        PunkRocker.SYMBOLS_NUM_IN_REEL[currReel.reelID] += (currSymSize - 4); // 4 count is added there on reel stop.
                    }

                    this.timeline.add([
                        currSym!.shakeMultiBeforeMysteryTransform(this.mysterySymbol, currSymSize),
                        currSym!.doLighteningBeforeMysteryTransform(this.mysterySymbol, currSymSize)
                    ], 0);
                }
            }
        });

        // #364
        this.timeline.addLabel("doTransform");

        PREngineManager.AllReels.forEach(currReel => {
            if (currReel.isActive) {
                const reelId: number = currReel.reelID;

                if (this.mysteryPos[currReel.reelID] >= 0) {
                    const symId: number = this.mysteryPos[reelId],
                        currSymSize: number = this._gameData.raw.symbolSizes[reelId][symId],
                        currSym: PunkSymbol | undefined = currReel.getSymbol(symId);

                    this.timeline.add(currSym!.transformMystery(this.mysterySymbol, currSymSize), "doTransform");

                    // #264
                    this.timeline.add(PunkRocker.checkAndApplyChalkDividerOnMysteryTransform(reelId, symId, currSym, PunkRocker.checkIfRevealedSymIsLow(this.mysterySymbol)), "doTransform+=0.2");
                }

                // might need below code for enabling dividers from code
                /*if (this.mysteryPos[currReel.reelID] >= 0 && this.mysteryPos[currReel.reelID] < currReel.windowConfHeight) {
                    let mystSym = currReel.getSymbol(this.mysteryPos[currReel.reelID])!;
                    let aboveSymbol = currReel.getSymbol(this.mysteryPos[currReel.reelID] - 1)!;
                    let belowSymbol = currReel.getSymbol(this.mysteryPos[currReel.reelID] + 1)!;

                    if (mystSym.isLowValue) {
                        mystSym.playLowRevealDividers(mystSym.posID[0] != currReel.windowConfAmount - 1 && belowSymbol.isLowValue);
                        if (aboveSymbol && aboveSymbol.isLowValue && aboveSymbol.posID[0] >= 0) {
                            aboveSymbol.createDivider(true);
                            aboveSymbol.enableDivider(true);
                        }
                    }
                }*/
            }
        });

        // #319
        if (isSuper) {
            let totalWays: number = 1;
            for (let i: number = 0; i < PunkRocker.SYMBOLS_NUM_IN_REEL.length; i++) {
                totalWays *= (PunkRocker.SYMBOLS_NUM_IN_REEL[i]);
            }
            this.timeline.add(PunkRocker.waysCounter.setValue(undefined, totalWays, 0.1));
        }
    }
}